import React, { useContext } from 'react';
import ProfileLink from '../ProfileLink';
import Slogan from '../Slogan';
import { Context } from '../../../../../context/AppContext';
import { ReviewItem } from '../../../../../components/Review';
import './styles.css';

const DropDown = ({ show, synopsis, url, recentReview, slogan, name }) => {
  const {
    media: { desktop, tablet },
  } = useContext(Context);
  return show && (synopsis || recentReview || slogan) ? (
    <div className="Listview__Card__synopsis">
      {recentReview ? (
        <div className="Listview__Card__synopsisRow Listview__Card__synopsisRow--reviews">
          <ReviewItem
            review={recentReview}
            lines={desktop || tablet ? 2 : 3}
            readMore={
              <ProfileLink url={url} anchor="#reviews">
                {' '}
                Discover reviews on {name}...
              </ProfileLink>
            }
          />
        </div>
      ) : null}
      {(synopsis || slogan) && (
        <div className="Listview__Card__synopsisRow">
          <div className="Listview__Card__synopsisHeading">About</div>
          {slogan && <Slogan tag="h2">{slogan}</Slogan>}
          {synopsis ? (
            <p>
              {synopsis}{' '}
              <ProfileLink url={url}>Learn more about {name}...</ProfileLink>
            </p>
          ) : (
            <p>
              <ProfileLink url={url}>Learn more about {name}...</ProfileLink>
            </p>
          )}
        </div>
      )}
    </div>
  ) : (
    ''
  );
};

export default DropDown;
